// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ReportDimension,
  ReportDimensionFromJSON,
  ReportDimensionToJSON,
  ReportMetric,
  ReportMetricFromJSON,
  ReportMetricToJSON,
} from "./";

/**
 * Aggregated results of a saved report
 * @export
 * @interface ReportTemplateResults
 */
export interface ReportTemplateResults {
  /**
   * Records the report runs over
   * @type {string}
   * @memberof ReportTemplateResults
   */
  dataset: ReportTemplateResultsDatasetEnum;
  /**
   * Bucket size applied to date dimensions
   * @type {string}
   * @memberof ReportTemplateResults
   */
  granularity?: ReportTemplateResultsGranularityEnum;
  /**
   * Records that matched the report before grouping, not the number of rows returned
   * @type {number}
   * @memberof ReportTemplateResults
   */
  totalRows: number;
  /**
   * Fields the rows are grouped by, in order
   * @type {Array<ReportDimension>}
   * @memberof ReportTemplateResults
   */
  dimensions: Array<ReportDimension>;
  /**
   * Values aggregated on each row
   * @type {Array<ReportMetric>}
   * @memberof ReportTemplateResults
   */
  metrics: Array<ReportMetric>;
  /**
   * One row per combination of dimension values
   * @type {Array<any>}
   * @memberof ReportTemplateResults
   */
  rows: Array<any>;
}

export function ReportTemplateResultsFromJSON(
  json: any
): ReportTemplateResults {
  return {
    dataset: json["dataset"],
    granularity: !exists(json, "granularity") ? undefined : json["granularity"],
    totalRows: json["total_rows"],
    dimensions: (json["dimensions"] as Array<any>).map(ReportDimensionFromJSON),
    metrics: (json["metrics"] as Array<any>).map(ReportMetricFromJSON),
    rows: json["rows"],
  };
}

export function ReportTemplateResultsToJSON(
  value?: ReportTemplateResults
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    dataset: value.dataset,
    granularity: value.granularity,
    total_rows: value.totalRows,
    dimensions: (value.dimensions as Array<any>).map(ReportDimensionToJSON),
    metrics: (value.metrics as Array<any>).map(ReportMetricToJSON),
    rows: value.rows,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ReportTemplateResultsDatasetEnum {
  TestCase = "TestCase",
  TestPlan = "TestPlan",
  Execution = "Execution",
  Issue = "Issue",
}
/**
 * @export
 * @enum {string}
 */
export enum ReportTemplateResultsGranularityEnum {
  Day = "day",
  Week = "week",
  Month = "month",
}
